import React from "react";

import "./index.scss";

import { Booked } from "./booked";
import { UnconnectedMessage } from "./unconnectedMessage";
import { TeamInitialMessage } from "./teamInitialMessage";
import { InitialMessage } from "./initialMessage";
import { NewMessage } from "./newMessage";

export const getNextActionCards = (
  enquiry: IEnquiry,
  itinerary: IEnquiryItinerarySummary,
  country: ICountry,
  lto: ILto,
  message: IMessage,
) => {
  const cards: JSX.Element[] = [];

  // LOW INTENT
  // Shown until enquiry status is no longer "Low Intent"
  if (enquiry?.enquiryStatus === EnquiryStatus.LowIntent) {
    cards.push(<UnconnectedMessage enquiry={enquiry} country={country} />)
  }

  // TRIAGE
  // Shown when the enquiry status is "Triage" and
  // until an LTO sends a message or itinerary message
  //
  // Check the messagingSummary.users array. If it only contains the user,
  // continue to show the message (so the user can't disable it with a message)
  if (enquiry?.enquiryStatus === EnquiryStatus.Triage &&
    enquiry?.messagingSummary?.users.length === 1 &&
    enquiry?.messagingSummary?.users[0]?.userType === UserType.Customer
  ) {
    cards.push(<TeamInitialMessage />)
  }

  // CONNECTED ("Classic")
  // Shown when the enquiry status is "New" and enquiry is connected to an LTO
  // until a user or an LTO sends a message or itinerary message
  if (enquiry?.enquiryStatus === EnquiryStatus.New &&
    enquiry.isConnected &&
    !enquiry?.messagingSummary?.recentMessage?.toCustomer &&
    !enquiry?.messagingSummary?.recentItineraryMessage
  ) {
    cards.push(<InitialMessage country={country} />)
  }

  // NEW MESSAGE/ITINERARY
  // Shown each time a new message or itinerary message is sent from an LTO/Admin
  // Shown until customerUpToDate is `true`
  // This is set when a customer visits the "Message" of "Itinerary" tab
  if (!enquiry?.messagingSummary?.customerUpToDate) {
    cards.push(<NewMessage enquiry={enquiry} message={message} lto={lto} />)
  }

  // BOOKED
  if (
    [EnquiryStatus.Booked, EnquiryStatus.FullyPaid, EnquiryStatus.InProgress]
      .some(status => enquiry?.enquiryStatus === status)
  ) {
    cards.push(<Booked key="booked" enquiry={enquiry} currentItinerary={itinerary} />);
  }

  return cards;
};
